import { useTheme } from '@emotion/react';
import { useSetAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Flex } from '~/components/blocks';
import { CancelWaitingForChargePane } from '~/components/partials/CancelWaitingForChargePane';
import { ActionButton } from '~/components/partials/ReceptionDrawer/ActionButton';
import { InactiveButton } from '~/components/partials/ReceptionDrawer/InactiveButton';
import { cancelPane } from '~/state/partials/cancel_pane/atoms';
import { chargeModalState } from '~/state/partials/charge_modal/atoms';

import { useCancelAppointment } from './use-cancel-appointment';

type Props = {
  appointmentId: string;
  draftAppointmentId: string | undefined;
  telemedicine: boolean;
  isSentCongestionNotification: boolean;
};

export const WaitingForChargeButtons = (props: Props) => {
  const { appointmentId, draftAppointmentId, telemedicine, isSentCongestionNotification } = props;
  const { canceling, handleCancel } = useCancelAppointment(appointmentId);
  const setCancelPane = useSetAtom(cancelPane);
  const theme = useTheme();

  const setChargeModalState = useSetAtom(chargeModalState);
  // 会計モーダルで確定後
  // - 未会計 -> 会計済(配送待ち) （telemedicine: true）
  // - 指導待ち -> 未会計 -> 完了 （telemedicine: false）
  const openChargeModal = useCallback(() => {
    setChargeModalState({
      appointmentId,
      isOpen: true,
    });
  }, [appointmentId, setChargeModalState]);

  // キャンセル
  const handleClickCancel = useCallback(() => {
    setCancelPane({ isOpen: true });
  }, [setCancelPane]);

  if (telemedicine) {
    return (
      <ActionButton use="primary" wide="fill" size="l" onClick={openChargeModal}>
        会計
      </ActionButton>
    );
  } else {
    return (
      <>
        <Flex flexDirection="column">
          <ActionButton use="primary" wide="fill" size="l" onClick={openChargeModal}>
            会計
          </ActionButton>
          <Flex alignItems="center" marginTop={theme.space.m}>
            <InactiveButton
              status={isSentCongestionNotification ? '送信済' : undefined}
              wide="half"
              size="m"
            >
              混雑時通知を送信
            </InactiveButton>
            <InactiveButton status="送信済" marginLeft={theme.space.m} wide="half" size="m">
              準備完了通知を送信
            </InactiveButton>
          </Flex>
          <ActionButton use="bgGrey" onClick={handleClickCancel} marginTop={theme.space.m} size="s">
            キャンセル
          </ActionButton>
        </Flex>
        <CancelWaitingForChargePane
          align="center"
          canceling={canceling}
          onCancel={handleCancel}
          draftAppointmentId={draftAppointmentId}
        />
      </>
    );
  }
};
